import { Component, Input, NgModule } from "@angular/core";

@Component({
    selector: "agm-map",
    template: "<ng-content></ng-content>",
    standalone: false,
})
export class AgmMapCompatComponent {
    @Input() fitBounds: boolean | null = null;
    @Input() zoom: number | null = null;
    @Input() maxZoom: number | null = null;
    @Input() mapTypeControl: boolean | null = null;
    @Input() disableDefaultUI: boolean | null = null;
}

@Component({
    selector: "agm-marker",
    template: "",
    standalone: false,
})
export class AgmMarkerCompatComponent {
    @Input() latitude: number | null = null;
    @Input() longitude: number | null = null;
    @Input() agmFitBounds: boolean | null = null;
}

@NgModule({
    declarations: [AgmMapCompatComponent, AgmMarkerCompatComponent],
    exports: [AgmMapCompatComponent, AgmMarkerCompatComponent],
})
export class AgmCompatModule {}
